module.exports = __webpack_public_path__ + "img/exam (5).4ad7b02c.png";